import React, { useState } from 'react';
import styles from './UnitTour.module.css';

const UnitTour = ({ unit }) => {
  const [proposedTime, setProposedTime] = useState('');
  const [proposals, setProposals] = useState([
    { type: 'tenant', text: 'Sunday, 3/5, 7pm', status: 'pending' },
    { type: 'landlord', text: 'Monday, 3/6, 7pm', status: 'proposed' },
  ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (proposedTime) {
      setProposals([
        ...proposals,
        { type: 'tenant', text: new Date(proposedTime).toLocaleString(), status: 'pending' },
      ]);
      setProposedTime('');
    }
  };

  return (
    <div className={styles.tourContainer}>
      <h2 className={styles.title}>Schedule a Tour</h2>

      <div className={styles.availability}>
        <h4>Tour Availability</h4>
        <div className={styles.availabilityGrid}>
          <div><strong>Sun</strong><br />12-8</div>
          <div><strong>Mon</strong><br />12-8</div>
          <div><strong>Tues</strong><br/>12-8</div>
          <div><strong>Wed</strong><br/>None</div>
          <div><strong>Thurs</strong><br/>12-8</div>
          <div><strong>Fri</strong><br/>12-8</div>
          <div><strong>Sat</strong><br/>None</div>
        </div>
      </div>

      <div className={styles.proposalSection}>
        {proposals.map((proposal, idx) => (
          <div
            key={idx}
            className={`${styles.proposalItem} ${
              proposal.type === 'landlord' ? styles.landlordProposal : styles.tenantProposal
            }`}
          >
            {proposal.text}
            {proposal.status === 'proposed' && proposal.type === 'landlord' && (
              <button className={styles.acceptBtn}>Accept?</button>
            )}
          </div>
        ))}
      </div>

      <form className={styles.tourForm} onSubmit={handleSubmit}>
        <label className={styles.formLabel}>
          Propose a time:
          <input
            type="datetime-local"
            value={proposedTime}
            onChange={(e) => setProposedTime(e.target.value)}
            step="900"
            className={styles.formInput}
          />
        <button type="submit" className={styles.submitBtn}>Send Proposal</button>
		</label>
      </form>
    </div>
  );
};

export default UnitTour;
